import {Component, OnInit} from '@angular/core';
import {AccessRequestService} from "../../_services/accessRequest.service";

@Component({
    standalone: false,
  selector: 'app-support-console',
  templateUrl: './support-console.component.html',
  styleUrls: ['./support-console.component.scss']
})
export class SupportConsoleComponent implements OnInit {
  accessRequest: any = {};
  accessRequests: any[];
  statuses = {0: 'Initiated', 1: 'Accepted', 2: 'Refused'};

  constructor(public accessRequestService: AccessRequestService) {
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.accessRequestService.getAccessRequests().subscribe(i => {
      this.accessRequests = i;
    });
  }

  addRequest() {
    this.accessRequestService.createAccessRequest(this.accessRequest).subscribe(i => {
        this.accessRequest = {};
        this.loadData();
      },
      (e) => {
        debugger;
      });
  }
}
